import { Phone, MapPin } from "lucide-react";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="relative bg-[#1A1A1A] text-[#F9F8F6] pt-24 pb-12 overflow-hidden"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12">
                <div className="grid grid-cols-12 gap-10">
                    <div className="col-span-12 md:col-span-6">
                        <img
                            src="https://customer-assets.emergentagent.com/job_luxury-facilitation/artifacts/6k1jx2uv_MP%20LOGO%20NEW.png"
                            alt="Monplaisir Group"
                            data-testid="footer-logo"
                            className="h-44 md:h-56 w-auto -ml-4 md:-ml-6"
                        />
                        <p className="mt-2 max-w-md font-sans text-[14px] text-[#F9F8F6]/70 leading-[1.85]">
                            Bespoke travel and lifestyle services.
                            <br />
                            Operating from London, attending the world.
                            <br />
                            CM Facilitation · CM Bespoke.
                        </p>
                    </div>

                    <div className="col-span-12 sm:col-span-6 md:col-span-3">
                        <div className="font-sans text-[10px] uppercase tracking-[0.4em] text-[#C5A880]">
                            Contact
                        </div>
                        <ul className="mt-6 space-y-4 font-sans text-[14px]">
                            <li className="flex items-start gap-3">
                                <Phone size={14} className="mt-1 text-[#C5A880] flex-shrink-0" />
                                <a
                                    href="tel:+447300444567"
                                    data-testid="footer-phone"
                                    className="hover:text-[#C5A880] transition-colors"
                                >
                                    +44 7300 444 567
                                </a>
                            </li>
                            <li className="flex items-start gap-3">
                                <MapPin size={14} className="mt-1 text-[#C5A880] flex-shrink-0" />
                                <span data-testid="footer-location" className="leading-relaxed">
                                    London, Kensington
                                    <br />
                                    Worldwide
                                </span>
                            </li>
                        </ul>
                    </div>

                    <div className="col-span-12 sm:col-span-6 md:col-span-3">
                        <div className="font-sans text-[10px] uppercase tracking-[0.4em] text-[#C5A880]">
                            Index
                        </div>
                        <ul className="mt-6 space-y-3 font-sans text-[14px]">
                            <li><a href="#about" className="hover:text-[#C5A880] transition-colors">Philosophy</a></li>
                            <li><a href="#services" className="hover:text-[#C5A880] transition-colors">Services</a></li>
                            <li><a href="#fleet" className="hover:text-[#C5A880] transition-colors">Fleet</a></li>
                            <li><a href="#partners" className="hover:text-[#C5A880] transition-colors">Partners</a></li>
                            <li><a href="#enquire" className="hover:text-[#C5A880] transition-colors">Enquire</a></li>
                        </ul>
                    </div>
                </div>

                <div className="mt-20 pt-6 border-t border-[#F9F8F6]/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 font-sans text-[11px] tracking-[0.22em] uppercase text-[#F9F8F6]/45">
                    <div className="flex flex-col gap-1">
                        <span>© {new Date().getFullYear()} Monplaisir - All rights reserved.</span>
                        <span data-testid="footer-licence" className="text-[#C5A880]/70">
                            TPH Operators Licence No: 010716
                        </span>
                    </div>
                    <span className="italic font-serif text-[#C5A880]/80 normal-case tracking-normal text-[13px]">
                        When was the last time something was your first time?
                    </span>
                </div>
            </div>
        </footer>
    );
}
